import { DialogActions } from '@mui/material';
import { StyledDialogContent } from '../styled/Dialog/StyledDialogContent';
import { useTranslation } from 'react-i18next';
import PrimaryBtn from '../shared/Buttons/PrimaryButton';
import ButtonOutlined from '../shared/Buttons/ButtonOutlined';
import useHandleBulkProductsToCart from '../../hooks/cart/useHandleBulkProductsToCart';
import { AddToCartProp } from '../../models/Cart';
import useShipmentLabelDetailsDialog from 'hooks/dialogs/useShipmentLabelDialog';
import { ShipmentsDetailsData } from 'models/Shipments';
import ShipmentLabelDetails from './ShipmentLabelDetails';
import ShipmentLabelProducts from './ShipmentLabelProducts';
import useShipmentProductsSWR from 'hooks/shipments/useShipmentProducts';

const ShipmentLabelDetailsWrapper = () => {
    const shipmentLabelDetailsDialog = useShipmentLabelDetailsDialog();
    const { t } = useTranslation('shipments', {
        keyPrefix: 'SHIPMENT_DETAILS',
    });
    const shipmentDetailsRow = shipmentLabelDetailsDialog.dialogContent;
    const handleBulkProductsToCart = useHandleBulkProductsToCart();

    const { products, isLoading, isError, productNumber } =
        useShipmentProductsSWR(shipmentDetailsRow.id);

    const convertProductsToCart = (
        products: ShipmentsDetailsData[]
    ): AddToCartProp[] => {
        return products.map((el) => {
            return {
                shopify_variant_id: el.shopify_variant_id,
                quantity: el.quantity,
                lineType: el.lineType,
            };
        });
    };

    const handleGoToCart = (): void => {
        shipmentLabelDetailsDialog.closeDialog();
    };

    const addToCart = () => {
        handleBulkProductsToCart.handleAddToCart(
            convertProductsToCart(products),
            'SHIPMENT_DETAILS.PRODUCTS_ADDED_DIALOG',
            'shipments',
            handleGoToCart
        );
    };

    return (
        <>
            <StyledDialogContent>
                <ShipmentLabelDetails shipmentLabel={shipmentDetailsRow} />
                <ShipmentLabelProducts
                    products={products}
                    isLoading={isLoading}
                    isError={isError}
                />
            </StyledDialogContent>
            <DialogActions>
                {!isLoading && (
                    <PrimaryBtn onClick={addToCart}>
                        {t('ADD_TO_CART')} ({productNumber})
                    </PrimaryBtn>
                )}
                <ButtonOutlined
                    onClick={shipmentLabelDetailsDialog.closeDialog}
                    sx={{ height: '40px' }}
                >
                    {t('CLOSE')}
                </ButtonOutlined>
            </DialogActions>
        </>
    );
};

export default ShipmentLabelDetailsWrapper;
